<template>
  <a class="message-bill smd-panel"
     target="_blank"
     :href="message.msg.url">
    <p class="Paragraph1 m-b-20">Kindly settle the following bill:</p>
    <div class="smd-form__row align-items-center">
      <img alt="Bill"
           class="message-bill__image"
           :src="$options.BillImage">
      <div class="message-bill__details">
        <div class="message-bill__amount">{{ amount | currency }}</div>
        <div class="message-bill__date">BILL DATE: {{ billDate }}</div>
      </div>
    </div>
  </a>
</template>

<script>
  import BillImage from '@/assets/images/bill.png';
  import {toPhilMoment} from '@/utils/dates';

  export default {
    name: 'MessageBill',
    props: {
      message: {type: Object, required: true},
    },
    computed: {
      amount() {
        const billObj = this.message.msg;

        if(billObj.rbgi) {
          return (billObj.subtotal || 0);
        } else {
          return billObj.subtotal + (billObj.serviceCharge || 0);
        }
      },
      billDate() {
        return toPhilMoment(this.message.msg.billDate).format('MMMM D, YYYY');
      },
    },
    BillImage
  }
</script>

<style lang="scss">
  .message-bill {
    @include border-radius(radius(medium));
    color: inherit;
    padding-right: space(l);
  }

  .message-bill__image {
    margin-right: space(m);
    width: 35px;
  }

  .message-bill__details {
    flex: 1;
    margin-bottom: space(s);
  }

  .message-bill__amount {
    @include font-style(Title3);
  }

  .message-bill__date {
    @include font-style(Label2);
    color: color(gray-400);
    text-transform: uppercase;
  }
</style>
